import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MiscService } from '../../_service/misc.service';
declare var $: any;
@Component({
  selector: 'app-user_add_edit',
  templateUrl: './user_add_edit.component.html',
  styleUrls: ['./user_add_edit.component.css']
})
export class CreateUserComponent implements OnInit {

    userForm: FormGroup;submitted = false;loading:boolean=false;circles=[];passwordhide:boolean = true;UserId: any = '';circles_copy=[];userRoles=[];treatCategory=[];myrole:string;cm_access='';tls=[];cms=[];tls_copy=[];cms_copy=[];
    
    constructor(public miscapi:MiscService,private userapi:UserService,private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,public leadapi:LeadsService,private activatedRoute: ActivatedRoute)
    {   

        this.getcircle();
        this.getUserRoles();
        this.getTreatmentCategory();
        this.getTls();
        this.getCms();
        let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
        let vaildEmailAddress: any = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
        let passwordPattern = "^[a-zA-Z0-9]{8,}$";

        this.userForm = this.formBuilder.group({ 
            'mobile' : [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
            'email': [null, Validators.compose([Validators.required, Validators.pattern(vaildEmailAddress)])],
            'name' : [null, Validators.required],
            'employee_id' : [null, Validators.required],
            'role' : [null, Validators.required],
            'all_access' : [null],
            'is_cm_access':[null], 
            'circle_id' : [null, Validators.required],
            'password': [null, Validators.compose([Validators.required, Validators.pattern(passwordPattern)])],
            'status' : [null, Validators.required],
            'treatment_catergory_access':[null],
            'tl_id':[null],
            'cm_id':[null],
            'is_presales_access':[null]
        });

        this.activatedRoute.params.subscribe(params => {
            if (params['user_id']) {
                this.UserId = params['user_id'];
                this.patchUserData();
                const userPass = this.userForm.get('password');
                userPass.clearValidators();
                userPass.updateValueAndValidity();
            }

        });

    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    sortFunc(a, b) {
        return 1;
      }

    get f() { return this.userForm.controls; }

    setSearchValue(){
        $("#circleSearch").val('');
        $("#circleSearch").focus();
        this.circles= this.circles_copy;
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        } else if (type == 'tls') {
            this.tls = this.sharedapi.searchData(searchtText, this.tls_copy, "name");
        } else if (type == 'cms') {
            this.cms = this.sharedapi.searchData(searchtText, this.cms_copy, "name");
        }
    }

    async patchUserData(){
        let userId = {
            "id": this.UserId,
            
        }
        await this.userapi.getUserData(userId).subscribe((response:any) => {
           if(response.status){
               this.userForm.patchValue({
                    'name':response.data.name,  
                    'mobile':response.data.mobile,  
                    'employee_id':response.data.employee_id,  
                    'email':response.data.email,  
                    'role':response.data.role,
                    'all_access': response.data.ins_all_access,
                    'is_cm_access': response.data.is_cm_access,   
                    'is_presales_access': response.data.is_presales_access,   
                    'circle_id':response.data.userCircles, 
                    'status':response.data.status, 
                    'treatment_catergory_access':response.data.userAssignedCat,
                    'tl_id':response.data.tl_id,
                    'cm_id':response.data.cm_id
               })
           }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy=this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTls()
    {
        await this.leadapi.getTlsForUser().subscribe((data:any) => {
            if(data.status)
            {
                this.tls = data.data;
                this.tls_copy=this.tls;
            }else{
                this.tls = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getCms()
    {
        await this.leadapi.getCms().subscribe((data:any) => {
            if(data.status)
            {
                this.cms = data.data;
                this.cms_copy=this.cms;
            }else{
                this.cms = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getUserRoles()
    {
        await this.leadapi.getUserRoles().subscribe((data:any) => {
            if(data.status)
            {
                this.userRoles = data.data;
            }else{
                this.userRoles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    ngOnInit(): void 
    {
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});

        this.myrole = localStorage.getItem('role');
        this.cm_access = localStorage.getItem('CMAccess');
    }

    showPassword() {
        this.passwordhide = !this.passwordhide;
    }

    async createUser(){
        //console.log(this.userForm.value); return false;
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.userForm.invalid) {
            this.loading = false;
            return;
        }
        
        //For Update User//
        if(this.UserId){
          this.userForm.value.id= parseInt(this.UserId); 

        await this.userapi.updateUser(this.userForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('User Update Successfully');
                this.router.navigateByUrl('/users');
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            });  
        }else{ 
            //For Add User//
          await this.userapi.addUser(this.userForm.value)
         .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('User Added Successfully');
                this.router.navigateByUrl('/users');
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            }); 
        }
    }


}

